import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-retry",
  "use": "icon-retry-usage",
  "viewBox": "0 0 17 19",
  "content": "<symbol viewBox=\"0 0 17 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-retry\">\n<path d=\"M2.5 11C2.5 9.35 3.17 7.85 4.26 6.76L2.84 5.34C1.4 6.79 0.5 8.79 0.5 11C0.5 15.08 3.55 18.44 7.5 18.93V16.91C4.67 16.43 2.5 13.97 2.5 11ZM16.5 11C16.5 6.58 12.92 3 8.5 3C8.44 3 8.38 3.01 8.32 3.01L9.41 1.92L8 0.5L4.5 4L8 7.5L9.41 6.09L8.33 5.01C8.39 5.01 8.45 5 8.5 5C11.81 5 14.5 7.69 14.5 11C14.5 13.97 12.33 16.43 9.5 16.91V18.93C13.45 18.44 16.5 15.08 16.5 11Z\" fill=\"#98A1B4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol